import { render } from "./CurationTabs.vue?vue&type=template&id=b56c830e&scoped=true"
import script from "./CurationTabs.vue?vue&type=script&lang=js"
export * from "./CurationTabs.vue?vue&type=script&lang=js"

import "./CurationTabs.vue?vue&type=style&index=0&id=b56c830e&scoped=true&lang=css"
import "./CurationTabs.vue?vue&type=style&index=1&id=b56c830e&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56c830e"]])

export default __exports__